module.exports = __webpack_public_path__ + "img/no_img.a5edbf8e.png";